const data = [
    {
        t1:"Skins",
        t2:"Uncommon",
        t3:"A",
        img:"4.png"
    },
    {
        t1:"Skins",
        t2:"Uncommon",
        t3:"C",
        img:"5.png"
    },
    {
        t1:"Skins",
        t2:"Uncommon",
        t3:"D",
        img:"6.png"
    },
    {
        t1:"Skins",
        t2:"Uncommon",
        t3:"E",
        img:"7.png"
    },
    {
        t1:"Background",
        t2:"Legendary",
        t3:"A",
        img:"6.png"
    }
]

export default data;